/* jshint undef: true, unused: true */

var notJquery = require('../not-jquery');

module.exports = function FormBuilderComponent (componentSettings, formBuilderInstance) {

  var nJ       = notJquery,
      internal = {},
      foBuFac  = {};

  internal.foBu = formBuilderInstance;



  foBuFac.setupComponent = function (componentSettings) {

    var foBu = internal.foBu;

    var componentObject,
        name           = foBu.getInputName(componentSettings.attributes.name),
        elementId      = foBu.getInputId(componentSettings.attributes.name || componentSettings.attributes.id),
        wrapperClass   = componentSettings.isChildComponent ? 'foBu__form-item-child' : 'foBu__form-item-wrapper',
        elementType    = componentSettings.elementType || 'input',
        element        = foBuFac.createElement(elementType),
        isFieldsetType = foBu.fieldsetTypes.includes(elementType),
        wrapper        = document.createElement(isFieldsetType ? 'fieldset' : 'div'),
        label          = foBu.createLabel(elementId, componentSettings);

    componentSettings.elementType = elementType;
    
    componentSettings.attributes.id = elementId;

    componentSettings.formId = foBu.settings.uid;

    componentSettings.domElement = element;
    componentSettings.domElement.foBuSettings = componentSettings;

    componentSettings.domWrapper = wrapper;

    if (componentSettings.visibility !== undefined && !componentSettings.visibility) {
      $(wrapper).hide();
    }

    if (componentSettings.data) {
      element.data = componentSettings.data;
    }

    if (foBu.hasSubWrapper.includes(elementType) === true) {
      element = document.createElement('div');
    }

    nJ.addClass(element, (componentSettings.inputLayoutClass) ? componentSettings.inputLayoutClass : foBu.settings.inputClass);

    nJ.addClass(element, foBu.settings.inputClass);
    nJ.addClass(element, 'form__' + elementType);

    foBu.addAttributes(element, componentSettings.attributes);

    if(element.tagName !== 'DIV') {
      foBu.addAttributes(element, {'name' : name});
    }

    element.id = elementId;

    nJ.addClass(element, 'form__' + componentSettings.elementType);

    wrapper.id = elementId + '-component-wrapper';
    nJ.addClass(wrapper, wrapperClass);
    if (componentSettings.wrapperClass) {
      nJ.addClass(wrapper, componentSettings.wrapperClass);
    }
    nJ.addClass(wrapper, wrapperClass + '--' + elementType);

    if (label) {
      wrapper.appendChild(label);
    }

    if (foBu.settings.hideInputsOfType.indexOf(elementType) > -1) {
      foBu.addAttributes(element, {'hidden' : 'hidden'});
    }

    // Add prefix to wrapper before input
    if (componentSettings.prefix) {
      wrapper.innerText = wrapper.innerText + ' ' + componentSettings.prefix;
      nJ.addClass(element, foBu.settings.uid + '--hasPrefix');
    }

    // If an input, not a multi-input, and not a parent element add to current inputs list
    if (
      foBu.inputTypes.includes(componentSettings.elementType.toLowerCase())
      &&
      foBu.fieldsetTypes.includes(componentSettings.elementType) === false
      &&
      foBu.parentInputs.includes(componentSettings.elementType) === false
      ||
      componentSettings.elementType === 'typeahead'
      ||
      componentSettings.elementType === 'inputwithbutton'
      ||
      componentSettings.elementType === 'autoComplete'
    ) {
      foBu.currentInputs.push(componentSettings);
    }

    if (typeof componentSettings.onUpdate === 'function') {
      foBu.manageEventListener(componentObject.element, 'change', function (event) {
        componentSettings.onUpdate(event, foBu);
      });
    }

    componentObject = {
      componentSettings : componentSettings,
      element           : element,
      wrapper           : wrapper,
      label             : label
    };


    return componentObject;
  };

  foBuFac.createElement = function (elementType) {
    var foBu = internal.foBu,
        element;

    if (foBu.inputElementTypes.includes(elementType.toLowerCase())) {
      element = document.createElement('input');
    } else if (foBu.parentInputs.includes(elementType.toLowerCase())) {
      element = document.createElement('div');
    } else {
      element = document.createElement(elementType);
    }

    return element;
  };



  internal.createValidationWrapper = function () {

    var foBu = internal.foBu,
        name = foBu.getInputName(componentSettings.attributes.name),
        messageWrapper = document.createElement('div'),
        wrapperClass   = ['input__messageWrapper-full-width', 'input__messageWrapper'];

    foBu.validation.rules[name] = componentSettings.validation;

    foBu.addAttributes(messageWrapper, {'id' : name + '__messageWrapper'});

    nJ.addClass(messageWrapper, wrapperClass);

    if (typeof componentSettings.messages !== 'undefined') {
      foBu.validation.messages[name] = componentSettings.messages;

    } else if (typeof componentSettings.attributes.placeholder !== 'undefined') {
      foBu.validation.messages[name] = 'Please enter your ' + componentSettings.attributes.placeholder.toLowerCase();
    } else {
      foBu.validation.messages[name] = 'Please enter your ' + componentSettings.attributes.name.toLowerCase();
    }

    return messageWrapper;
  };



  internal.setupValidation = function () {

    var foBu            = internal.foBu,
        componentObject = internal.componentObject;

    if (componentSettings.elementType === 'input') {
      foBu.manageEventListener(componentObject.element, 'blur', function (event) {
        foBu.validation.validateElement(foBu.settings.uid, event.target.name);
      });
    }
    if (typeof componentSettings.validation !== 'undefined') {

      var messageWrapper = internal.createValidationWrapper();

      componentObject.wrapper.appendChild(messageWrapper);
    }
  };



  foBuFac.finaliseComponent = function () {

    var componentObject = internal.componentObject;

    if (!internal.foBu.noAppendInFinalisation.includes(componentSettings.elementType)) {
      componentObject.wrapper.appendChild(componentObject.element);
    }

    internal.setupValidation();

  };



  foBuFac.getComponentObject = function() {
    return internal.componentObject;
  };

  internal.componentObject = foBuFac.setupComponent(componentSettings);


  return foBuFac;
};
